import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

// `as const` keeps the labels literal, so the enums that use them get typed
// constants (for example `SuspensionReason.OTHER`).
export const BehaviourLabels = {
  CONTINUED_DISOBEDIENCE:
    'Continued/persistent disobedience and/or disruptive behaviour',
  MALICIOUS_DAMAGE: 'Malicious damage to, or theft of, property',
  VERBAL_ABUSE: 'Verbal abuse',
  BULLYING_CYBERBULLYING: 'Bullying and cyber-bullying',
  MISUSE_OF_TECHNOLOGY: 'Mis-use of technology',
  DISCRIMINATION:
    'Discrimination, including that based on sex, race, religion, disability, sexual orientation or gender identity',
  OTHER_BEHAVIOUR_OF_CONCERN: 'Other - Behaviour of concern',
  POSSESSION_OF_SUBSTANCES:
    'Being in possession of, use or supply of tobacco, alcohol, vapes and e-cigarettes',
  POSSESSION_OF_ILLEGAL_SUBSTANCE:
    'Possession of, use or supply of a suspected illegal/restricted substance',
  WEAPONS_POSSESSION_USE:
    'Being in possession of, or using, weapons including firearms and knives (excluding kirpans, in line with LIB22)',
  IMPLEMENT_AS_WEAPON: 'Using an implement as a weapon',
  THREATENING_VIOLENT_BEHAVIOUR:
    'Seriously threatening or engaging in physically violent behaviour',
  SERIOUS_CRIMINAL_BEHAVIOUR:
    'Engaging in serious criminal behaviour related to the school',
  SEXUAL_HARASSMENT:
    'Engaging in sexual harassment, sexual assault or sexualised behaviour that may pose a risk of or has caused physical, psychological or emotional harm to others.',
  OTHER_SERIOUS_BEHAVIOUR: 'Other – serious behaviour of concern',
  OTHER: 'Other',
} as const;

export const SuspensionCategory = BaseEnum.create({
  values: [
    { value: 1, label: 'Formal Caution' },
    { value: 2, label: 'Suspension' },
  ],
});

export const SuspensionState = BaseEnum.create({
  values: [
    { value: 0, label: 'Unknown' },
    { value: 1, label: 'Linked Expulsion' },
    { value: 2, label: 'Pending' },
    { value: 3, label: 'In Progress' },
    { value: 4, label: 'Finalised' },
  ],
});

export const SuspensionOutcome = BaseEnum.create({
  values: [
    { value: 0, label: 'Unresolved' },
    { value: 1, label: 'Not Required' },
    { value: 2, label: 'Returned to School' },
    { value: 3, label: 'Placement in Another School' },
    { value: 4, label: 'Placement in an Alternative Program' },
    { value: 5, label: 'Early Return to School' },
  ],
});

export const SuspensionTabs = BaseEnum.create({
  values: [
    { value: 0, label: 'Pending' },
    { value: 1, label: 'Formal Cautions' },
    { value: 2, label: 'Suspensions' },
    { value: 3, label: 'Extended Suspensions' },
    { value: 4, label: 'Completed Suspensions' },
  ],
});

export const ApprovalReason = BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Suspension exceeds day limit for single suspension' },
    {
      value: 2,
      label: 'Exceeds number of allowed suspensions for a calendar year',
    },
    { value: 3, label: 'Exceeds suspended days limit for a calendar year' },
    { value: 4, label: 'Extension' },
  ],
});

export const NotificationReason = BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Kindergarten suspension' },
    {
      value: 2,
      label: 'Spans calendar years',
    },
    { value: 3, label: 'Exceeds day limit' },
    { value: 4, label: 'Generic' },
  ],
});

export const SuspensionReason = BaseEnum.create({
  values: [
    {
      value: 1,
      label: BehaviourLabels.CONTINUED_DISOBEDIENCE,
    },
    { value: 2, label: BehaviourLabels.MALICIOUS_DAMAGE },
    { value: 3, label: BehaviourLabels.VERBAL_ABUSE },
    { value: 4, label: BehaviourLabels.BULLYING_CYBERBULLYING },
    { value: 5, label: BehaviourLabels.MISUSE_OF_TECHNOLOGY },
    {
      value: 6,
      label: BehaviourLabels.DISCRIMINATION,
    },
    { value: 7, label: BehaviourLabels.OTHER_BEHAVIOUR_OF_CONCERN },
    {
      value: 8,
      label: BehaviourLabels.POSSESSION_OF_SUBSTANCES,
    },
    {
      value: 9,
      label: BehaviourLabels.POSSESSION_OF_ILLEGAL_SUBSTANCE,
    },
    {
      value: 10,
      label: BehaviourLabels.WEAPONS_POSSESSION_USE,
    },
    {
      value: 11,
      label: BehaviourLabels.IMPLEMENT_AS_WEAPON,
    },
    {
      value: 12,
      label: BehaviourLabels.THREATENING_VIOLENT_BEHAVIOUR,
    },
    {
      value: 13,
      label: BehaviourLabels.SERIOUS_CRIMINAL_BEHAVIOUR,
    },
    {
      value: 14,
      label: BehaviourLabels.SEXUAL_HARASSMENT,
    },
    { value: 15, label: BehaviourLabels.OTHER_SERIOUS_BEHAVIOUR },
    { value: 16, label: BehaviourLabels.OTHER },
  ],
});
